import { motion } from "framer-motion";

import styles from '../styles';
import { staggerContainer, fadeIn, planetVariants } from '../utils/motion';
import { NewFeatures, TitleText, TypingText } from "../components";

import { newFeatures } from '../constants'

const Artefact = () => (
  <section className={`${styles.paddings} relative z-10`}>
    <motion.div
      variants={staggerContainer}
      initial='hidden'
      whileInView='show'
      viewport={{ once:false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto flex lg:flex-row flex-col gap-8`}
    >
      <motion.div
        variants={fadeIn('right', 'tween', 0.2, 1)}
        className='flex-[0.75] flex justify-center flex-col'
      >
        <TypingText title="| Artefacts" />
        <TitleText title={<>I farm vermillion everyday</>} />
        <div className="mt-[48px] flex flex-wrap justify-between gap-[24px]">
          {
            newFeatures.map((feature, index) => (
              <NewFeatures
                key={feature.title}
                {...feature}
              />
            ))
          }
        </div>
      </motion.div>
      <motion.div
        variants={planetVariants('right')}
        className={`flex-1 ${styles.flexCenter}`}
      >
        <img 
          src="/artefact.png" 
          alt="artefact"
          className="w-[75%] h-[75%] object-contain" 
        />
      </motion.div>
    </motion.div>
  </section>
);

export default Artefact;
